import { CardServiceApiFactory, type ModelCardRequest, type ModelCardResponse } from '@layup/api-sdk';
import type { ICard } from '../models/cards';
import { createLayupClient } from './layupApi';

export const cardServiceClient = () => {
  const client = createLayupClient();
  return CardServiceApiFactory(undefined, undefined, client);
};

export async function createCard(modelCardRequest: ModelCardRequest): Promise<ModelCardResponse> {
  const response = await cardServiceClient().cardServiceCreate({ modelCardRequest });
  return response.data;
}

export async function verifyCard(checkoutId: string) {
  const client = createLayupClient(false);
  const response = await client.get(`v1/cards/${checkoutId}/redirect?isEmbeddedCheckout=true`);
  return response;
}

export async function getCards(): Promise<ModelCardResponse[]> {
  const response = await cardServiceClient().cardServiceGetMany();
  return response.data.clientCards!;
}

export async function getCard(id: string): Promise<ICard> {
  const client = createLayupClient();
  const response = await client.get(`/v1/cards/${id}`);
  return response.data as ICard;
}

export async function deleteCard(id: string): Promise<{}> {
  const response = await cardServiceClient().cardServiceRemove({ id });
  return response.data;
}

export const updateCard = async (card: ModelCardResponse) => {
  const response = await cardServiceClient().cardServiceUpdate({ id: card._id || '', modelCardRequest: card });
  return response.data;
};
